export default __webpack_public_path__ + "static/media/amrut.757aef2c.png";